import { SortArrow } from '@shared/assets/icons/components';
import { type FC } from 'react';
import classNames from 'classnames';

import { THeadCellText, type THeadCellTextProps } from '../thead-cell-text';
import styles from './thead-cell-sortable-tooltip.module.scss';
import { Flex, Tooltip } from 'antd';
import { ConditionalWrapper } from '@shared/ui/conditional-wrapper';
import { Text, type TypographyVariant } from '@shared/ui/antd';

const MAX_TEXT_LENGTH = 80;

export type THeadCellSortableTooltipProps = THeadCellTextProps & {
  isSorted?: boolean;
  isDesc?: boolean;
  text?: string | null;
  variant?: TypographyVariant;
  fontWeight?: React.CSSProperties['fontWeight'];
  maxLength?: number;
  onSort?: () => void;
};

export const THeadCellSortableTooltip: FC<THeadCellSortableTooltipProps> = ({
  children,
  isSorted,
  isDesc,
  width,
  text,
  variant = 'md',
  fontWeight = 400,
  maxLength = MAX_TEXT_LENGTH,
  onSort,
  ...props
}) => {
  const sortClassNames = classNames(styles.sort, {
    [styles.sort_sorted]: isSorted,
    [styles.sort_asc]: isSorted && !isDesc,
  });

  const hasLongText = text && text?.length > maxLength;
  const textSlice = hasLongText ? `${text.slice(0, maxLength)}...` : text;

  return (
    <THeadCellText className={styles.root} onClick={onSort} {...props} width={width}>
      <ConditionalWrapper
        condition={hasLongText || false}
        wrapper={(children) => (
          <Tooltip
            title={text}
            placement="topLeft"
            style={{ textAlign: 'left', maxWidth: '600px' }}
          >
            {children}
          </Tooltip>
        )}
      >
        <Flex
          align="center"
          style={{
            columnGap: '4px',
            width,
          }}
        >
          <Text variant={variant} fontWeight={fontWeight}>
            {textSlice}
          </Text>
          <SortArrow width="16px" height="16px" className={sortClassNames} />
        </Flex>
      </ConditionalWrapper>
    </THeadCellText>
  );
};
